/**
 * ImportEmptyState — écran Importer quand aucun cheval n'est sélectionnable.
 *
 * Rendu par la couche routing À LA PLACE de CsvUploadPage (le formulaire n'est
 * jamais affiché avec un sélecteur vide). Choix des textes uniquement :
 *   - `onAddHorse` fourni (droit d'ajout, même condition que « Ajouter un
 *     cheval ») → sous-titre d'invitation + CTA d'ajout ;
 *   - sinon (compte invité) → sous-titre « aucun cheval partagé », sans CTA ;
 *   - `onViewHorses` fourni (chevaux possédés archivés) → lien « Voir mes chevaux ».
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusCircle } from 'lucide-react';
import { getTheme, RADIUS } from '../constants/theme';
import EmptyState from '../shared/EmptyState';

const ImportEmptyState = ({ onAddHorse, onViewHorses, darkMode }) => {
  const { t: tr } = useTranslation();
  const t = getTheme(darkMode);
  return (
    <div data-testid="import-empty-state" style={{
      background: t.card, border: `1px solid ${t.border}`, borderRadius: RADIUS.md, padding: '30px',
    }}>
      <EmptyState
        title={tr('sessions.csv.empty.title')}
        subtitle={tr(onAddHorse ? 'sessions.csv.empty.subtitle' : 'sessions.csv.empty.subtitleGuest')}
        primaryAction={onAddHorse && { label: tr('horses.list.empty.cta'), onClick: onAddHorse, Icon: PlusCircle }}
        secondaryAction={onViewHorses && { label: tr('sessions.csv.empty.viewHorses'), onClick: onViewHorses }}
        darkMode={darkMode}
      />
    </div>
  );
};

export default ImportEmptyState;
